export const BRANDS_STATE = 'BRANDS';
